import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { CommonService } from 'src/app/services/common.service';
import { ReportsService } from 'src/app/services/reports.service';
import { MediaContentService } from 'src/app/services/media-content.service';
import { ImageData } from 'src/app/model/ImageData/ImageData';
import { MapMarker } from 'src/app/model/MapMarker';
import { Config } from 'src/app/config';
import { GalleryItem } from '../gallery-item/gallery-item.component';

@Component({
  selector: 'vrm-gallery-container',
  templateUrl: './gallery-container.component.html',
  styleUrls: ['./gallery-container.component.scss'],
})
export class GalleryContainerComponent implements OnInit {
  showDetails: boolean = false;
  @Input() loading: boolean;
  @Input() galleryHasContent: boolean;
  @Output() onLoad: EventEmitter<boolean> = new EventEmitter<boolean>();

  selectedItem: GalleryItem;
  derMediaData: GalleryItem[] = [];

  constructor(
    public cService: CommonService,
    private rptService: ReportsService,
    private mediaContentService: MediaContentService
  ) {}

  ngOnInit() {
    this.logInputData();

    if (this.reportHasMediaEndpoints()) {
      const resolved = this.resolveMediaEndpoints();

      if (!resolved.success) {
        this.cService.showToast(this.cService.readyTranslations.messagesAndWarnings.requestedAssetNotAvailable);
        return;
      }

      this.mediaContentService.getMedia(resolved.uri).subscribe({
        next: (mediaData: ImageData) => {
          const mediaItem: GalleryItem = { media: mediaData };
          this.derMediaData = [...this.derMediaData, mediaItem];
        },
        error: () => {
          this.onLoad.emit();
        },
        complete: () => {
          this.addMapMarkerIfPresentInSelectedRow();
          this.onLoad.emit();
        },
      });
    }
  }

  private logInputData(): void {
    console.log('%c Selected Row & Endpoint data', 'color: salmon', {
      selectedRow: this.rptService.selectedRows[0],
      endpoints: this.rptService.commonReportDrilldownEndpoints,
    });
  }

  private reportHasMediaEndpoints(): boolean {
    return (
      this.rptService.commonReportDrilldownEndpoints?.images ||
      this.rptService.commonReportDrilldownEndpoints?.documents
    );
  }

  private resolveMediaEndpoints(): {
    success: boolean;
    uri: string;
  } {
    const imageDataEndpoint =
      this.rptService.commonReportDrilldownEndpoints.images || this.rptService.commonReportDrilldownEndpoints.documents;

    return this.cService.resolveUriSegments(imageDataEndpoint['GET'], this.rptService.selectedRows[0]);
  }

  private addMapMarkerIfPresentInSelectedRow(): void {
    if (this.rptService.selectedRows[0]?.question_latitude && this.rptService.selectedRows[0]?.question_longitude) {
      const map: MapMarker = {
        latitude: this.rptService.selectedRows[0].question_latitude,
        longitude: this.rptService.selectedRows[0].question_longitude,
        address: this.rptService.selectedRows[0]?.question_address,
      };
      const mapItem: GalleryItem = { map: map };

      if (
        this.derMediaData.length > 0 &&
        this.derMediaData[0]['fileName'] === 'intelligent-vehicle-damage-report.pdf'
      ) {
        const iddPdf = this.derMediaData.shift();
        this.derMediaData = [iddPdf, mapItem, ...this.derMediaData];
      } else {
        this.derMediaData = [mapItem, ...this.derMediaData];
      }
    }
  }

  onClickedItem(selectedItem: GalleryItem): void {
    this.showDetails = true;
    this.selectedItem = selectedItem;
  }

  onGoBackFromDetailClicked(): void {
    this.showDetails = false;
  }

  private composeExportUrl(): string {
    const selectedRow = this.rptService.selectedRows[0];
    const employeeNumber = selectedRow.pin;
    const submissionId = selectedRow.submissionId;
    const language = this.cService.userProfile.languageCode;
    const securePin = this.rptService.currentReportMeta.information?.encryptedPin ?? false;

    return `${Config.apiRoot.uri}/reports/driver_event_reporting/export/${employeeNumber}/${submissionId}/${language}?securePin=${securePin}`;
  }

  exportReport(): void {
    const exportUrl = this.composeExportUrl();
    const selectedRow = this.rptService.selectedRows[0];
    const fileName = `DER-${selectedRow.question_vehicle_identifier}-${selectedRow.submissionId}.zip`;

    this.mediaContentService.downloadBlobFromUrl(exportUrl, fileName, true);
  }
}
